//Pages
import Users from "../Components/Pages/Users";
import AccountTypesList from "../Components/Pages/AccountTypes/AccountTypesList";
import UserLogs from "../Components/Pages/UserLogs";

import Roles from "../Components/Pages/Roles/RolesList";
import DashboardDefault from "../Components/Pages/Dashboard/Default";
import SystemEmails from "../Components/Pages/SystemEmails/SystemEmailsList";
import Deposits from "../Components/Pages/Deposits";
import Withdrawals from "../Components/Pages/Withdrawals";
import InternalTransfer from "../Components/Pages/InternalTransfer";
import IbRequests from "../Components/Pages/IbRequests/IbRequestsList";
import AccountRequests from "../Components/Pages/AccountRequests/AccountRequestsList";
import Clients from "../Components/Pages/Clients";
// import Detail from "../Components/Pages/Clients/ContactApp";
import ClientDetail from "../Components/Pages/ClientDetail/ClientDetail";
import ErrorPage4 from "../Components/Pages/ErrorPages/ErrorPage404";
import BannersList from "../Components/Pages/Banners/BannersList";

import Leads from "../Components/Pages/Leads";
import Ibs from "../Components/Pages/Ibs";

import Reports from "../Components/Pages/Reports";
import Editprofile from "../Components/Pages/Profile/Editprofile";

// import TicketList from "../Components/Pages/TicketList/TicketList";
import Tickets from "../Components/Todo/index";

export const routes = [
  //page
  {
    path: `${process.env.PUBLIC_URL}/dashboard`,
    Component: <DashboardDefault />,
  },
  { path: `${process.env.PUBLIC_URL}/users`, Component: <Users /> },
  {
    path: `${process.env.PUBLIC_URL}/account-types`,
    Component: <AccountTypesList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/banners`,
    Component: <BannersList />,
  },
  { path: `${process.env.PUBLIC_URL}/roles`, Component: <Roles /> },
  {
    path: `${process.env.PUBLIC_URL}/system-emails`,
    Component: <SystemEmails />,
  },
  { path: `${process.env.PUBLIC_URL}/user-logs`, Component: <UserLogs /> },

  { path: `${process.env.PUBLIC_URL}/deposits`, Component: <Deposits /> },
  { path: `${process.env.PUBLIC_URL}/withdrawals`, Component: <Withdrawals /> },
  {
    path: `${process.env.PUBLIC_URL}/internal-transfers`,
    Component: <InternalTransfer />,
  },
  { path: `${process.env.PUBLIC_URL}/ib-requests`, Component: <IbRequests /> },
  // { path: `${process.env.PUBLIC_URL}/ticket-list`, Component: <Tickets /> },
  // { path: `${process.env.PUBLIC_URL}/ticket-list`, Component: <TicketList /> },
  { path: `${process.env.PUBLIC_URL}/tickets`, Component: <Tickets /> },
  {
    path: `${process.env.PUBLIC_URL}/account-requests`,
    Component: <AccountRequests />,
  },
  { path: `${process.env.PUBLIC_URL}/clients`, Component: <Clients /> },
  { path: `${process.env.PUBLIC_URL}/leads`, Component: <Leads /> },
  { path: `${process.env.PUBLIC_URL}/ibs`, Component: <Ibs /> },

  {
    path: `${process.env.PUBLIC_URL}/clients/:id`,
    Component: <ClientDetail />,
  },
  { path: `${process.env.PUBLIC_URL}/leads/:id`, Component: <ClientDetail /> },
  { path: `${process.env.PUBLIC_URL}/ibs/:id`, Component: <ClientDetail /> },

  { path: `${process.env.PUBLIC_URL}/reports`, Component: <Reports /> },
  { path: `${process.env.PUBLIC_URL}/reports`, Component: <Reports /> },
  { path: `${process.env.PUBLIC_URL}/profile`, Component: <Editprofile /> },
  
  {
    path: `${process.env.PUBLIC_URL}/page-not-found`,
    Component: <ErrorPage4 />,
  },
];
